import { useNavigate } from 'react-router-dom'
import { ShoppingBag } from 'lucide-react'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'
import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import { useCart } from '../hooks/useCart'
import { CartItem } from './CartItem'

function formatPrice(cents: number): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100)
}

export function CartDrawer() {
  const { items, isOpen, closeCart, subtotalCents, itemCount } = useCart()
  const navigate = useNavigate()

  function handleCheckout() {
    closeCart()
    navigate('/shop/checkout')
  }

  function handleShop() {
    closeCart()
    navigate('/shop')
  }

  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && closeCart()}>
      <SheetContent className="flex w-full flex-col gap-4 p-6 sm:max-w-md">
        <SheetHeader>
          <SheetTitle>
            Cart {itemCount > 0 && <span className="text-muted-foreground">({itemCount})</span>}
          </SheetTitle>
        </SheetHeader>

        {items.length === 0 ? (
          <div className="flex flex-1 flex-col items-center justify-center gap-3 text-muted-foreground">
            <ShoppingBag className="h-12 w-12 opacity-30" />
            <p className="text-sm">Your cart is empty.</p>
            <Button variant="outline" size="sm" className="mt-2" onClick={handleShop}>
              View the store
            </Button>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto">
              <div className="divide-y">
                {items.map((item) => (
                  <CartItem key={`${item.productId}-${item.variantId}`} item={item} />
                ))}
              </div>
            </div>

            <div className="space-y-3 pt-4">
              <Separator />
              <div className="flex justify-between text-sm font-medium">
                <span>Subtotal</span>
                <span>{formatPrice(subtotalCents)}</span>
              </div>
              <p className="text-xs text-muted-foreground">
                Shipping and taxes calculated at checkout.
              </p>
              <Button className="w-full" onClick={handleCheckout}>
                Checkout
              </Button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  )
}
